<kendo-label [text]="label()"
             class="text-grey">
    <kendo-textbox [value]="displayValue"
                   [disabled]="true">
    </kendo-textbox>
</kendo-label>